import classnames from 'classnames';
import get from 'lodash/get';
import maxBy from 'lodash/maxBy';

export default {
  computed: {
    isDeleted() {
      return this.item.deleted_at !== null;
    },

    isGuest() {
      return this.item.guest_id === null;
    },

    isPaid() {
      // For Viva orders, we need to check the viva_status
      if (
        ['iris', 'googlePay_applePay'].includes(
          // eslint-disable-next-line camelcase
          this.item.checkout_method?.slug,
        )
      ) {
        return this.item.viva_status === 'F';
      }

      return !!this.item.transaction;
    },

    isUnfinished() {
      return this.item.is_unfinished;
    },

    isNew() {
      return get(this, 'status.slug', 'new') === 'new';
    },

    status() {
      return maxBy(this.item.statuses, 'order');
    },

    classes() {
      if (this.isDeleted || this.isUnfinished) {
        return 'tag is-medium is-danger';
      }

      if (this.isNew) {
        return 'tag is-medium is-warning';
      }

      return classnames('tag is-medium', {
        'is-primary': this.status.slug === 'for_delivery',
        'is-info': this.status.slug === 'confirm',
        'is-white': !['for_delivery', 'new', 'confirm'].includes(
          this.status.slug,
        ),
      });
    },

    orderMethodTitle() {
      return get(this.item, 'order_method.title', '');
    },

    checkoutMethodTitle() {
      return get(this.item, 'checkout_method.title', '');
    },

    sendMethodTitle() {
      return get(this.item, 'send_method.title', '');
    },
  },
};
